
import React from 'react';
import { Search, Users, CreditCard, Shield } from 'lucide-react';
import { useLanguage } from '@/hooks/useLanguage';

export const HowItWorksSection = () => {
  const { t } = useLanguage();
  const Hoststeps = [
    {
      icon: Search,
      title: t('searchTitle', 'howItWorks'),
      description: t('searchDesc', 'howItWorks'),
    },
    {
      icon: Users,
      title: t('connectTitle', 'howItWorks'),
      description: t('connectDesc', 'howItWorks'),
    },
    {
      icon: CreditCard,
      title: t('payTitle', 'howItWorks'),
      description: t('payDesc', 'howItWorks'),
    },
    {
      icon: Shield,
      title: t('travelTitle', 'howItWorks'),
      description: t('travelDesc', 'howItWorks'),
    },

  ];


  const Gueststeps = [
      {
      icon: Search,
      title: t('GuestsearchTitle', 'howItWorks'),
      description: t('GuestsearchDesc', 'howItWorks'),
    },
    {
      icon: Users,
      title: t('GuestconnectTitle', 'howItWorks'),
      description: t('GuestconnectDesc', 'howItWorks'),
    },
    {
      icon: CreditCard,
      title: t('GuestpayTitle', 'howItWorks'),
      description: t('GuestpayDesc', 'howItWorks'),
    },
    {
      icon: Shield,
      title: t('GuesttravelTitle', 'howItWorks'),
      description: t('GuesttraveDesc', 'howItWorks'),
    },
  ]

  return (
    <section id="how-it-works" className="pt-8 pb-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-5">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-6xl font-light text-gray-900 mb-6">
            {t('sectionTitle', 'howItWorks')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-bold">
  {t('sectionSubtitle', 'howItWorks')}
</p>

        
          </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Line */}
          {/*<div className="hidden lg:block absolute top-1/2 left-0 right-0 h-px bg-gray-200 transform -translate-y-1/2 z-0"></div>*/}
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
            {Hoststeps.map((step, index) => (
              <div key={index} className="text-center group">
                {/* Step Icon */}
                <div className="relative mb-8">
                  <div className="w-20 h-20 mx-auto rounded-full bg-[#FFF8E9] flex items-center justify-center group-hover:bg-[#0EA674] transition-all duration-300 relative z-10 shadow-lg">
                    <step.icon className="w-8 h-8 text-[#0EA674] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-[#0EA674] text-white rounded-full flex items-center justify-center text-sm font-medium z-20">
                    {index + 1}
                  </div>
                </div>

                {/* Content */}
                <div className="space-y-4">
                  <h3 className="text-2xl font-medium text-gray-900">
                    {step.title}
                  </h3>
                  
                  <p className="text-gray-600 font-light leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-5">
        {/* Section Header */}
        <div className="text-center mb-20">
          
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-bold">
  {t('GuestsectionSubtitle', 'howItWorks')}
</p>

        
          </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Line */}
         {/* <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-px bg-gray-200 transform -translate-y-1/2 z-0"></div> */}
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
            {Gueststeps.map((step, index) => (
              <div key={index} className="text-center group">
                {/* Step Icon */}
                <div className="relative mb-8">
                  <div className="w-20 h-20 mx-auto rounded-full bg-[#FFF8E9] flex items-center justify-center group-hover:bg-[#DB9800] transition-all duration-300 relative z-10 shadow-lg">
                    <step.icon className="w-8 h-8 text-[#DB9800] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-[#DB9800] text-white rounded-full flex items-center justify-center text-sm font-medium z-20">
                    {index + 1}
                  </div>
                </div>

                {/* Content */}
                <div className="space-y-4">
                  <h3 className="text-2xl font-medium text-gray-900">
                    {step.title}
                  </h3>
                  
                  <p className="text-gray-600 font-light leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
